import { useSearchParams } from "react-router-dom"

const useQueryParams = () => {
    const [searchParams, setSearchParams] = useSearchParams()

    // Get all parameters as an object
    const getAllParams = () => {
        const params = {}
        for (const [key, value] of searchParams.entries()) {
            params[key] = value
        }
        return params
    }

    // Get a specific parameter value
    const getParam = (key) => {
        return searchParams.get(key)
    }

    // Set/Update a parameter
    const setParam = (key, value, options = { replace: false }) => {
        const newParams = new URLSearchParams(searchParams)
        if (value === null || value === undefined || value === '') {
            newParams.delete(key)
        } else {
            newParams.set(key, value)
        }
        setSearchParams(newParams, options)
    }

    // Delete a parameter
    const deleteParam = (key, options = { replace: false }) => {
        const newParams = new URLSearchParams(searchParams)
        newParams.delete(key)
        setSearchParams(newParams, options)
    }

    // Update multiple parameters at once
    const updateParams = (paramsObject, options = { replace: false }) => {
        const newParams = new URLSearchParams(searchParams)
        
        Object.entries(paramsObject).forEach(([key, value]) => {
            if (value === null || value === undefined || value === '') {
                newParams.delete(key)
            } else {
                newParams.set(key, value)
            }
        })
        
        setSearchParams(newParams, options)
    }

    // Clear all parameters
    const clearParams = (options = { replace: false }) => {
        setSearchParams(new URLSearchParams(), options)
    }

    // Check if a parameter exists
    const hasParam = (key) => {
        return searchParams.has(key)
    }

    return {
        // Raw access to searchParams if needed
        searchParams,
        setSearchParams,
        
        // Convenient methods
        getAllParams,
        getParam,
        setParam,
        deleteParam,
        updateParams,
        clearParams,
        hasParam
    }
}

export default useQueryParams
